import { Model } from "../../shared-features/models/model";

export class DriversBlock extends Model{
  driverId: number;
  customerId: number;
  reason: string;
  customerName: string;
}
